import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from 'shared/shared.module';
import { CustomFieldsModule } from 'shared/custom-fields/custom-fields.module';
import { InterchangeModule } from 'shared/interchange/interchange.module';
import { ScrollToService } from 'shared/base/scroll-to.service';

import { ConfigureExportWidgetComponent } from './configure-export-widget/configure-export-widget.component';
import { BaseConfigureExportModalComponent } from './configure-export-modal/_base-configure-export-modal.component';
import { ConfigureExportModalComponent } from './configure-export-modal/configure-export-modal.component';
/* eslint-disable */
import { ConfigureWorkingExportModalComponent } from './configure-export-modal/configure-working-export-modal/configure-working-export-modal.component';
import { ConfigureReceiverExportModalComponent } from './configure-export-modal/configure-receiver-export-modal/configure-receiver-export-modal.component';
import { ConfigureScheduleExportModalComponent } from './configure-export-modal/configure-schedule-export-modal/configure-schedule-export-modal.component';
/* eslint-enable */
import { ReceiverSearchComponent } from './receiver-search/receiver-search.component';
import { PricingSheetSearchComponent } from './pricing-sheet-search/pricing-sheet-search.component';
import { ConfigureExportNameComponent } from './configure-export-name/configure-export-name.component';
import { AdvancedExportOptionsComponent } from './advanced-export-options/advanced-export-options.component';
import { ExportPriceSheetOptionsComponent } from './export-price-sheet-options/export-price-sheet-options.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    CustomFieldsModule,
    InterchangeModule,
  ],
  declarations: [
    ConfigureExportModalComponent,
    ConfigureWorkingExportModalComponent,
    ConfigureExportWidgetComponent,
    ConfigureReceiverExportModalComponent,
    ConfigureScheduleExportModalComponent,
    ReceiverSearchComponent,
    PricingSheetSearchComponent,
    ConfigureExportNameComponent,
    BaseConfigureExportModalComponent,
    AdvancedExportOptionsComponent,
    ExportPriceSheetOptionsComponent,
  ],
  exports: [ConfigureExportWidgetComponent],
  providers: [
    ScrollToService,
  ]
})
export class ConfigureExportWidgetModule { }
